import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

import { EElevators } from '../../../../../../../json_query';
import { InlineParam } from '../../../markup';

export interface IElevatorsProps {
  elevatorsCount: EElevators;
  onElevatorsChanged(value: EElevators): void;

  hasServiceLift: boolean;
  onChangedCheckbox(value: boolean): void;
}

export const Elevators: React.StatelessComponent<IElevatorsProps> = props => {
  function changeElevators(value: EElevators) {
    if (value === EElevators.Two) {
      props.onChangedCheckbox(true);
      props.onElevatorsChanged(EElevators.Any);

      return;
    }

    props.onElevatorsChanged(value);
    props.onChangedCheckbox(false);
  }

  const elevatorsCount = props.hasServiceLift ? EElevators.Two : props.elevatorsCount;

  return (
    <>
      <InlineParam>
        <DropdownField
          value={elevatorsCount}
          onValueChange={changeElevators}
          values={[
            { value: EElevators.Any, label: 'Неважно' },
            { value: EElevators.One, label: 'Есть любой' },
            { value: EElevators.Two, label: 'Есть грузовой' },
          ]}
        />
      </InlineParam>
    </>
  );
};
